module.exports = __webpack_public_path__ + "static/media/Shot.svg";